import React from 'react'

import type { VideoElementState } from 'EditorApp/types'
import VideoOrImage from 'components/VideoOrImage'

interface Props {
  element: VideoElementState
  preview: boolean
}

const VideoElement = ({ element, preview }: Props) => {
  const videoWidth = element.width / element.cropFractions.width
  const videoHeight = element.height / element.cropFractions.height

  const left = -element.cropFractions.left * videoWidth
  const top = -element.cropFractions.top * videoHeight
  const transform = `scaleX(${element.isFlipped ? -1 : 1})`

  const source = {
    url: preview ? `${element.url}.png` : element.url,
    formats: preview ? [] : element.formats,
  }

  return (
    <div
      className="VideoElement"
      data-element-id={element.id}
      style={{
        width: element.width,
        height: element.height,
        backgroundColor: element.backgroundColor,
        borderRadius: element.borderRadius,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <VideoOrImage
        key={element.url}
        source={source}
        style={{
          position: 'absolute',
          objectFit: 'contain',
          left: left,
          top: top,
          width: videoWidth,
          height: videoHeight,
          transform: transform,
        }}
      />
    </div>
  )
}

export default VideoElement
